module.exports = __webpack_public_path__ + "assets/img/nanjing.e2456e1f.png";